import { all, call, fork, put, takeEvery } from "redux-saga/effects";
import {
  FETCH_ANALYTICS_OVERVIEW,
  FETCH_ANALYTICS_ENGAGEMENT,
  FETCH_ANALYTICS_GENRES,
  FETCH_ANALYTICS_LEADERBOARDS,
  FETCH_ANALYTICS_BOOKS,
  FETCH_ANALYTICS_USERS,
  FETCH_ANALYTICS_SESSIONS,
  EXPORT_ANALYTICS_CSV,
} from "../ActionTypes";
import {
  getAnalyticsOverview,
  getAnalyticsEngagement,
  getAnalyticsGenres,
  getAnalyticsLeaderboards,
  getAnalyticsBooks,
  getAnalyticsUsers,
  getAnalyticsSessions,
  downloadAnalyticsCsv,
} from "../Api";
import {
  fetchAnalyticsOverviewSuccess,
  fetchAnalyticsOverviewFailure,
  fetchAnalyticsEngagementSuccess,
  fetchAnalyticsEngagementFailure,
  fetchAnalyticsGenresSuccess,
  fetchAnalyticsGenresFailure,
  fetchAnalyticsLeaderboardsSuccess,
  fetchAnalyticsLeaderboardsFailure,
  fetchAnalyticsBooksSuccess,
  fetchAnalyticsBooksFailure,
  fetchAnalyticsUsersSuccess,
  fetchAnalyticsUsersFailure,
  fetchAnalyticsSessionsSuccess,
  fetchAnalyticsSessionsFailure,
  exportAnalyticsCsvSuccess,
  exportAnalyticsCsvFailure,
} from "../Actions";

const errorMessage = (error) => error.response?.data?.message || error.message || "Request failed";

function* runRequest(apiFunction, successAction, failureAction, payload) {
  try {
    const response = yield call(apiFunction, payload);
    yield put(successAction(response));
  } catch (error) {
    yield put(failureAction(errorMessage(error)));
  }
}

function* overviewRequest() {
  yield* runRequest(
    getAnalyticsOverview,
    fetchAnalyticsOverviewSuccess,
    fetchAnalyticsOverviewFailure
  );
}
function* engagementRequest({ payload }) {
  yield* runRequest(getAnalyticsEngagement, fetchAnalyticsEngagementSuccess, fetchAnalyticsEngagementFailure, payload);
}
function* genresRequest({ payload }) {
  yield* runRequest(getAnalyticsGenres, fetchAnalyticsGenresSuccess, fetchAnalyticsGenresFailure, payload);
}
function* leaderboardsRequest({ payload }) {
  yield* runRequest(getAnalyticsLeaderboards, fetchAnalyticsLeaderboardsSuccess, fetchAnalyticsLeaderboardsFailure, payload);
}
function* booksRequest({ payload }) {
  yield* runRequest(getAnalyticsBooks, fetchAnalyticsBooksSuccess, fetchAnalyticsBooksFailure, payload);
}
function* usersRequest({ payload }) {
  yield* runRequest(getAnalyticsUsers, fetchAnalyticsUsersSuccess, fetchAnalyticsUsersFailure, payload);
}
function* sessionsRequest({ payload }) {
  yield* runRequest(getAnalyticsSessions, fetchAnalyticsSessionsSuccess, fetchAnalyticsSessionsFailure, payload);
}
function* exportRequest({ payload }) {
  yield* runRequest(downloadAnalyticsCsv, exportAnalyticsCsvSuccess, exportAnalyticsCsvFailure, payload);
}

function* watchOverview() { yield takeEvery(FETCH_ANALYTICS_OVERVIEW, overviewRequest); }
function* watchEngagement() { yield takeEvery(FETCH_ANALYTICS_ENGAGEMENT, engagementRequest); }
function* watchGenres() { yield takeEvery(FETCH_ANALYTICS_GENRES, genresRequest); }
function* watchLeaderboards() { yield takeEvery(FETCH_ANALYTICS_LEADERBOARDS, leaderboardsRequest); }
function* watchBooks() { yield takeEvery(FETCH_ANALYTICS_BOOKS, booksRequest); }
function* watchUsers() { yield takeEvery(FETCH_ANALYTICS_USERS, usersRequest); }
function* watchSessions() { yield takeEvery(FETCH_ANALYTICS_SESSIONS, sessionsRequest); }
function* watchExport() { yield takeEvery(EXPORT_ANALYTICS_CSV, exportRequest); }

export default function* overviewSagas() {
  yield all([
    fork(watchOverview),
    fork(watchEngagement),
    fork(watchGenres),
    fork(watchLeaderboards),
    fork(watchBooks),
    fork(watchUsers),
    fork(watchSessions),
    fork(watchExport),
  ]);
}
